import {TOrderSubDetail} from '../../../../../redux/types'

export function formatEndUser(args: TOrderSubDetail) {
  const {end_user, end_user_multiple} = args
  return end_user_multiple ? end_user?.replaceAll(',', ', ') : end_user
}
